<template>
  <div id="viewChild">
    <div class="box">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部订单" name="99"></el-tab-pane>
        <el-tab-pane label="待付款" name="0"></el-tab-pane>
        <el-tab-pane label="待发货" name="1"></el-tab-pane>
        <el-tab-pane label="待收货" name="3"></el-tab-pane>
        <el-tab-pane label="待评价" name="4"></el-tab-pane>
      </el-tabs>
      <div v-if="!isEmpty">
        <div class="order-item" v-for="(item,index) of orders" :key="index">
          <div class="title lv3Text">
            {{dayjs.unix(item.create_time).format("YYYY-MM-DD hh:mm:ss")}}
            <span
              style="margin-left:10px"
            >订单编号：{{item.orderCode}}</span>
          </div>
          <div class="content">
            <div v-for="(item2,index2) of item.products" :key="index2">
              <el-row class="product-row">
                <el-col :span="3">
                  <div>
                    <el-image
                      style="width: 100px; height: 100px"
                      :src="serve +item2.images"
                      fit="cover"
                    ></el-image>
                  </div>
                </el-col>
                <el-col :span="13">
                  <div class="lv2Text t1">{{item2.title}}</div>
                  <div class="lv3Text">
                    {{item2.item_no}}
                    <span style="margin-left:10px">数量： x{{item2.number}}</span>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="lv0Text" style="padding-top: 20px">{{item.text}}</div>
                </el-col>
                <el-col :span="4">
                  <div
                    v-if="index2==0"
                    class="lv2Text"
                    style="padding-top:20px"
                  >实付：&yen;{{item.pay_money}}</div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isEmpty" class="lv4Text empty">没有订单</div>
      <div class="pager" align="center">
        <el-pagination background hide-on-single-page layout="prev, pager, next" :total="total"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,
      //
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      c_mobile: this.$route.query.user,
      activeName: "99",
      page: 1,
      total: 0,
      orders: null,
      isEmpty: null
    };
  },
  watch: {},
  created() {
    //
    this.$store.state.user_location = "子账户管理";
    this.$store.state.user_location2 = "查看子账户订单";
    this.$store.state.leftMenuIndex = 11;
    this.initData();
  },
  methods: {
    load(status) {
      if (status == "99") {
        status = null;
      }
      this.axios
        .get(this.serve + "/personal/my_children_order", {
          params: {
            mobile: this.mobile,
            token: this.token,
            c_mobile: this.c_mobile,
            page: 1,
            status: status
          }
        })
        .then(res => {
          if (res.data.msg == "搜索结果为空") {
            this.isEmpty = true;
          } else {
            this.isEmpty = false;
            this.orders = res.data.data.results;
            for (var item of this.orders) {
              var obj = JSON.parse(item.product_list);
              item.products = obj;
              if (item.status == 0) {
                item.text = "待付款";
              } else if (item.status == 1) {
                item.text = "待发货";
              } else if (item.status == 2 || item.status == 3) {
                item.text = "待收货";
              } else if (item.status == 4) {
                item.text = "待评价";
              } else if (item.status == 5) {
                item.text = "已完成";
              } else if (item.status == 6) {
                item.text = "已取消";
              }
            }
          }
        });
    },
    handleClick(v) {
      this.load(v.name);
    },
    initData() {
      this.load(99);
    }
  }
};
</script>
<style lang="scss">
#viewChild {
  .box {
    .empty {
      padding: 20px 0;
      text-align: center;
    }
    .t1 {
      margin: 15px 0;
    }
    .product-row {
      border-bottom: 1px solid #ddd;
      padding: 10px 20px;
    }
    .order-item {
      margin-bottom: 20px;
      .title {
        padding: 20px;
        font-size: 12px;
        border-bottom: 1px solid #ddd;
      }
      background-color: #f5f5f5;
      border: 1px solid #ddd;
      padding-bottom: 0;
    }
    background-color: #fff;
    padding: 20px 30px;
    border: 1px solid #ddd;
  }
}
</style>